export default __webpack_public_path__ + "static/media/numbers.08684f77.png";